import React from "react";

// A real break between days, not a whisper. The rule runs the full width and
// the date sits ON it in a cream chip, so you cannot scroll past a day boundary
// without registering it.
//
// The key is the LOCAL calendar day, the same day the label below names. It was
// the UTC day, which in US Eastern turns over at 8pm (7pm in winter): an
// afternoon post and an evening post from the same day then got two separate
// breaks, both reading "Yesterday".
export function dayKey(d) {
  if (!d) return "";
  const t = new Date(d);
  if (Number.isNaN(t.getTime())) return "";
  return `${t.getFullYear()}-${t.getMonth() + 1}-${t.getDate()}`;
}

// "Today" / "Yesterday" / "Tuesday" / "12 August". Soft on purpose: a precise
// timestamp makes a record, and a record is something you are careful in front of.
function label(d) {
  if (!d) return "";
  const then = new Date(d);
  const now = new Date();
  const days = Math.round((now.setHours(0, 0, 0, 0) - new Date(then).setHours(0, 0, 0, 0)) / 86400000);
  if (days === 0) return "Today";
  if (days === 1) return "Yesterday";
  if (days < 7) return then.toLocaleDateString("en-US", { weekday: "long" });
  return then.toLocaleDateString("en-US", { month: "long", day: "numeric" });
}

function DayBreak({ when }) {
  return (
    <div className="relative text-center my-[38px] first:mt-[24px]">
      <span className="absolute inset-x-0 top-1/2 h-px bg-dupontGoldLt/40" aria-hidden="true" />
      <span className="relative bg-dupontCream dark:bg-neutral-900 px-[16px]
                       font-blairBody font-medium text-[12px] tracking-[0.16em]
                       uppercase text-gray-400">
        {label(when)}
      </span>
    </div>
  );
}

export default DayBreak;
